const testStoryPaths = {
    "table": "organisms-table",
};

export const getTestStory = (component: string, storyName: string): string => {
    return `${testStoryPaths[component.toLowerCase().replace(/^ux-/, "")]}--${storyName.toLowerCase()}`
};

